export default function isValidDate(arr) {
  var year = arr[0],
      month = arr[1],
      date = arr[2];
    if(!year && !month && !date){
        return true;
    }
  var dateObj = new Date(year, month-1, date),
      nYear = dateObj.getFullYear(),
      nMonth = dateObj.getMonth() + 1,
      nDate = dateObj.getDate();

  if (year == nYear && month == nMonth && date == nDate) {
      return true;
  } else {
      return false;
  }
}


// WEBPACK FOOTER //
// ./src/tools/timescheck.js